export default class Language {
  public id: string
  public name: string

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }
}



// WEBPACK FOOTER //
// ./src/modules/consumer/models/Language.ts